import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

import {zIndexes} from '../../constants/index';

export const StyledBasketProductImage = styled(Box)(({theme}) => ({
  width: 60,
  height: 60,
  position: 'relative',
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.grey[50],
  cursor: 'pointer'
}));

export const StyledRibbons = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  zIndex: zIndexes.zIndexOne
}));

export const IconBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));
